<template>
  <div
    @click="handleInstructionsButtonClick"
    v-touch="handleInstructionsButtonClick"
    :class="$style.instructionsButtonContainer"
  >
    <MenuIcon></MenuIcon>
  </div>
</template>

<script>
import MenuIcon from "./svgs/MenuIcon";
export default {
  components: {
    MenuIcon
  },
  methods: {
    handleInstructionsButtonClick() {
      this.$bus.$emit("show-instructions-card");
      this.$bus.$emit("show-full-overlay");
    }
  }
};
</script>

<style lang='scss' module>
@import "../assets/css/globals.scss";

.instructions-button-container {
  position: absolute;
  top: 20px;
  left: 5px;
  padding: 20px;

  color: white;

  z-index: 800;

  cursor: pointer;

  @include large {
    left: 55px;
    padding: 0;
  }

  & svg {
    width: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MenuButton.vue